import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";
import { ContextMenuItemState } from "../ContextMenuItemState";

export class BfxBlotterOrdersContextMenuSeparator extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.SEPARATOR,
      "",
      function checkAvailable(
        menuState: BfxBlotterOrdersContextMenuState,
        itemState: ContextMenuItemState,
      ) {
        itemState.available =
          menuState.canTransfer ||
          menuState.canTransferUnrestricted ||
          menuState.canTransfer ||
          menuState.canTransferUnrestricted;
      },
      function checkEnabled(
        menuState: BfxBlotterOrdersContextMenuState,
        itemState: ContextMenuItemState,
      ) {
        itemState.enabled = false;
      },
    );
  }
}
